import { ApiEndpoint } from '../constants/api-endpoint.enum';
import { HttpService } from './http.service';

export class PostalCodeDataService {
  static async fetch(searchTerm: string): Promise<string[]> {
    return HttpService.performGetRequest(`${ApiEndpoint.AUTOCOMPLETE_POSTAL_CODES}/${searchTerm}`);
  }
}
